import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import React from "react";

import styles from './WelcomeStart.module.css'
import DoneIcon from '../../assets/icons/done.svg'
import QrCodeImg from '../../assets/images/qr-code.png'
import NextArrow from '../../assets/icons/arrow_downward.png'
import {Button, Col} from "react-bootstrap";
import {Link} from "react-router-dom";


const WelcomeStart = () => {
    return (
        <div>
            <Container className={styles.welcomestart} fluid>
                <div className={styles.centeredheader}>
                    <h1 className={styles.whiteheader}>Карта</h1>
                    <br/>
                    <h1 className={styles.whiteheader}>
                        "ВХОДилка"
                    </h1>
                </div>
            </Container>
            <br/>
            <Container>
                <Row>
                    <Col>
                        <h2>
                            О карте
                        </h2>
                        <p>
                            Карта «ВХОДилка» позволяет ознакомиться и освоить новые задачи
                            <br/>
                            Обеспечить работника необходимой информацией при «ВХОДе» в Университет
                        </p>
                    </Col>
                </Row>
            </Container>

            <br/><br/>

            <Container>
                <Row>
                    <Col sm={6}>
                        <div className={styles.vcenter}>
                            <h2>QR - код</h2>

                            <p>
                                Для открытия карты "ВХОДилка" отсканируйте QR-код c помощью камеры
                                вашего телефона или перейдите нажав по
                                <a href="/step1"> ссылке</a>
                                <br/>
                                Если что-то пошло не так, обратитесь за помощью к конечному держателю
                            </p>
                        </div>
                    </Col>
                    <Col sm={6}>
                        <img src={QrCodeImg} width={240}/>
                    </Col>
                </Row>
            </Container>

            <br/><br/>

            <Container>
                <Row>
                    <h2>
                        Навигационное меню "ВХОДилки"
                    </h2>
                </Row>
                <Row>
                    <a style={{all: "revert"}} href={"/step1"}>
                        <div className={styles.stepwrapper}>
                            <span><b>1й этап</b></span>
                            <br/>
                            <span>Кадровые вопросы</span>
                        </div>
                    </a>

                    <img src={NextArrow} className={styles.onlyphone}/>

                    <a style={{all: "revert"}} href={"/step2"}>
                        <div className={styles.stepwrapper}>
                            <span><b>2й этап</b></span>
                            <br/>
                            <span>Медицинский осмотр</span>
                        </div>
                    </a>

                    <img src={NextArrow} className={styles.onlyphone}/>

                    <a style={{all: "revert"}} href={"/step3"}>
                        <div className={styles.stepwrapper}>
                            <span><b>3й этап</b></span>
                            <br/>
                            <span>Оформление электронного пропуска</span>
                        </div>
                    </a>

                    <img src={NextArrow} className={styles.onlyphone}/>

                    <a style={{all: "revert"}} href={"/step4"}>
                        <div className={styles.stepwrapper}>
                            <span><b>4й этап</b></span>
                            <br/>
                            <span>Здания НИУ ВШЭ</span>
                        </div>
                    </a>

                    <img src={NextArrow} className={styles.onlyphone}/>

                    <a style={{all: "revert"}} href={"/step5"}>
                        <div className={styles.stepwrapper}>
                            <span><b>5й этап</b></span>
                            <br/>
                            <span>Единый личный кабинет работника</span>
                        </div>
                    </a>

                    <img src={NextArrow} className={styles.onlyphone}/>

                    <a style={{all: "revert"}} href={"/step6"}>
                        <div className={styles.stepwrapper}>
                            <span><b>6й этап</b></span>
                            <br/>
                            <span>Оборудовать рабочее место</span>
                        </div>
                    </a>

                    <img src={NextArrow} className={styles.onlyphone}/>

                    <a style={{all: "revert"}} href={"/step7"}>
                        <div className={styles.stepwrapper}>
                            <span><b>7й этап</b></span>
                            <br/>
                            <span>Заработная плата</span>
                        </div>
                    </a>

                    <img src={NextArrow} className={styles.onlyphone}/>

                    <a style={{all: "revert"}} href={"/step8"}>
                        <div className={styles.stepwrapper}>
                            <span><b>8й этап</b></span>
                            <br/>
                            <span>Базовый стандарт профессиональных компетенций</span>
                        </div>
                    </a>

                    <img src={NextArrow} className={styles.onlyphone}/>

                    <a style={{all: "revert"}} href={"/step9"}>
                        <div className={styles.stepwrapper}>
                            <span><b>9й этап</b></span>
                            <br/>
                            <span>Адаптационные семинары в НИУ ВШЭ</span>
                        </div>
                    </a>

                    <img src={NextArrow} className={styles.onlyphone}/>

                    <a style={{all: "revert"}} href={"/step10"}>
                        <div className={styles.stepwrapper}>
                            <span><b>10й этап</b></span>
                            <br/>
                            <span>Центр повышения квалификации</span>
                        </div>
                    </a>

                    <img src={NextArrow} className={styles.onlyphone}/>

                    <a style={{all: "revert"}} href={"/step11"}>
                        <div className={styles.stepwrapper}>
                            <span><b>11й этап</b></span>
                            <br/>
                            <span>Кадровый резерв</span>
                        </div>
                    </a>

                    <img src={NextArrow} className={styles.onlyphone}/>

                    <div className={styles.startbluewrapper}>
                        <div style={{paddingTop: "4px"}}>
                            <img src={DoneIcon} width={48}/>
                            <span style={{color: "#FFFFFF", paddingLeft: "12px"}}><b>Вы прошли все 11 этапов!</b></span>
                        </div>
                    </div>
                </Row>
            </Container>

            <Container>
                <div className={styles.hcenter} style={{marginTop: "100px"}}>
                    <Button className={styles.hcenter} variant="outline-primary" href="/step1" size="lg">Войти в
                        команду</Button>{' '}
                </div>
            </Container>

        </div>
    );
};

export default WelcomeStart;